import NumberFormat from "react-number-format";
import { Field, ErrorMessage } from "formik";
import Error from "./ErrorMessage";
import { TextField } from "@mui/material";

export default function Number(props: any) {
  const { name, ...rest } = props;

  return (
    <>
      <Field name={name}>
        {(fieldProps: any) => {
          const { field, form } = fieldProps;
          const { setFieldValue, values } = form;

          return (
            // <NumberFormat
            //   customInput={TextField}
            //   value={values[name]}
            //   onValueChange={(val) => setFieldValue(name, val.floatValue)}
            //   variant="outlined"
            //   allowNegative={false}
            //   {...rest}
            // />
            <TextField
              {...field}
              {...rest}
              type="number" // Set the type to "number" to enable the back button
              variant="outlined"
              inputProps={{
                min: 0, // Set the minimum value to 0 to prevent negative numbers
                inputMode: "numeric", // Hint for the browser about the expected input type
              }}
              value={values[name]} // Use the value from formik
              onChange={(event) => {
                // Update formik value when the input changes
                setFieldValue(name, event.target.value);
              }}
            />
          );
        }}
      </Field>
      <ErrorMessage name={name} component={Error} />
    </>
  );
}
